import axios from "axios";

export const API_BASE_URL = "https://api.campus-pulse.net/api";
// export const API_BASE_URL = "http://localhost:5500/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

/* ================= Automatic Refresh Token Handler ================= */
// إضافة interceptor بيتعامل مع حالات 401 (Unauthorized) ويحاول يعمل refresh للـ tokens تلقائي
// ملاحظات مهمة: السيرفر لازم يوفر endpoint بيجدد الـ access token باستخدام الـ refresh token
// والـ refresh token محطوط في cookie (httpOnly). هنا بنستعمل request منفصل عشان متحصلش حلقة لانهاء ال interceptor.

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Instance منفصل للـ refresh علشان ميشتغلش عليه الـ interceptor نفسه
const refreshApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// اسم endpoint للـ refresh ممكن يكون مختلف عندك. لو عندك اسم آخر غيّره هنا (مثال: "/Auth/refresh" أو "/Auth/refresh-token").
const REFRESH_ENDPOINT = "/Auth/refresh";

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // لو مافيش response أو status مش 401 رجّع الخطأ عادي
    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error);
    }

    // منع محاولة إعادة المحاولة أكتر من مرة
    if (originalRequest._retry) {
      return Promise.reject(error);
    }

    // لو في عملية تنشيط جارية، نضع الطلب في قائمة للانتظار لحد ما يخلص
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(() => {
          // بعد ما يتم عمل refresh، نعيد تنفيذ الطلب الأصلي
          return api(originalRequest);
        })
        .catch((err) => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      // نادِي endpoint التجديد. بما إن الـ refresh token موجود في cookie و withCredentials=true
      // السيرفر متوقع يرجع cookie جديد للـ accessToken أو يترك الـ cookie بتتغير هناك.
      await refreshApi.post(REFRESH_ENDPOINT);

      processQueue(null);
      isRefreshing = false;

      // بعد التجديد نحاول نعيد تنفيذ الطلب الأصلي
      return api(originalRequest);
    } catch (err) {
      processQueue(err, null);
      isRefreshing = false;

      // هنا ممكن تعمل logout للمستخدم أو توجيهه للـ login حسب منطق التطبيق
      // مثلاً: await api.post('/Auth/logout') أو استدعاء دالة logoutAdmin()

      return Promise.reject(err);
    }
  },
);

/* ================= AUTH ================= */

export const login = (email, password) =>
  api.post("/Auth/login", { email, password });

export const logout = () => api.post("/Auth/logout");

export default api;
